// Web Push subscription helpers
import api from "@/lib/api";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const b64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(b64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) arr[i] = raw.charCodeAt(i);
  return arr;
};

export const pushSupported = () =>
  typeof window !== "undefined"
  && "serviceWorker" in navigator
  && "PushManager" in window
  && "Notification" in window;

export async function getSWRegistration() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  return reg;
}

export async function getCurrentSubscription() {
  if (!pushSupported()) return null;
  const reg = await getSWRegistration();
  return reg ? await reg.pushManager.getSubscription() : null;
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Deze browser ondersteunt geen meldingen.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Toestemming voor meldingen geweigerd.");
  const { data } = await api.get("/push/public-key");
  const key = data?.key;
  if (!key) throw new Error("Server-sleutel ontbreekt.");
  const reg = await getSWRegistration();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(key),
    });
  }
  const json = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
  return true;
}

export async function disablePush() {
  const sub = await getCurrentSubscription();
  if (!sub) return true;
  const endpoint = sub.endpoint;
  await sub.unsubscribe();
  try { await api.delete(`/push/subscribe?endpoint=${encodeURIComponent(endpoint)}`); } catch (e) {}
  return true;
}

export async function sendTestPush() {
  await api.post("/push/test", {});
}
